module.exports = __webpack_public_path__ + "img/vn_qrcode_tk.885fe8c.webp";